import { ReactElement } from "react";
import { Provider, ErrorBoundary } from "@rollbar/react";
import { getEnvironmentName } from "lib/environment/environment-finder";
import getEnvVariables from "lib/environmentVariables/getEnvVariables";

const rollbarConfig = {
  accessToken: getEnvVariables().rollbarPostClientToken,
  captureUncaught: true,
  captureUnhandledRejections: true,
  environment: getEnvironmentName(),
  checkIgnore: () => {
    // Ignore errors in the dev environment
    return getEnvironmentName() === "development";
  },
  payload: {
    client: {
      javascript: {
        code_version: "1.0.0",
        source_map_enabled: true,
      },
    },
  },
};
const RollbarProvider = ({
  children,
}: {
  children: ReactElement;
}): ReactElement => {
  return (
    <Provider config={rollbarConfig}>
      <ErrorBoundary>{children}</ErrorBoundary>
    </Provider>
  );
};

export default RollbarProvider;
